import { PropsWithChildren, useState } from 'react'
import { createSafeContext } from '../create-safe-context'

type SideBarContextValue = {
  isOpen: boolean
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>
  siteWithChemical: Record<string, string[]>
  setSiteWithChemical: React.Dispatch<
    React.SetStateAction<Record<string, string[]>>
  >
  regionWithSite: Record<string, string[]>
  setRegionWithSite: React.Dispatch<
    React.SetStateAction<Record<string, string[]>>
  >
}

const [SideBarContextProvider, useSideBarContext] =
  createSafeContext<SideBarContextValue>('SideBarContext')

export { useSideBarContext }

export default function SidebarProvider({ children }: PropsWithChildren) {
  const [isOpen, setIsOpen] = useState(true)

  const [siteWithChemical, setSiteWithChemical] = useState<
    Record<string, string[]>
  >({})
  const [regionWithSite, setRegionWithSite] = useState<
    Record<string, string[]>
  >({})

  return (
    <SideBarContextProvider
      value={{
        isOpen,
        setIsOpen,
        siteWithChemical,
        setSiteWithChemical,
        regionWithSite,
        setRegionWithSite,
      }}
    >
      {children}
    </SideBarContextProvider>
  )
}
